module.exports = __webpack_public_path__ + "static/img/PSD16-SF_W1.a4451ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/PSD16-SF_W1.png
// module id = IJiJ
// module chunks = 1